// src/layouts/placement/PlacementMenu.jsx
import { SVGICON } from '../constant/theme';

export const PlacementMenuList = [
  {
    title: 'Dashboard',
    classsChange: 'mm-collapse',
    iconStyle: SVGICON.DataTable,
    eventKey: 'placement-dashboard',
    to: 'placement-dashboard',
    content: [],
  },
  {
    title: 'HR Contacts',
    classsChange: 'mm-collapse',
    iconStyle: SVGICON.DataTable,
    eventKey: 'contacts',
    to: 'contacts',
    content: [],
  },
  {
    title: 'Organization',
    classsChange: 'mm-collapse',
    iconStyle: SVGICON.DataTable,
    eventKey: 'organizations',
    to: 'organizations',
    content: [],
  },
  {
    title: 'Job Profile',
    classsChange: 'mm-collapse',
    iconStyle: SVGICON.DataTable,
    eventKey: 'job-profiles',
    // Canonical route for Job Profile per user request
    to: 'job-profiles',
    content: [],
  },
  {
    title: 'Students',
    classsChange: 'mm-collapse',
    iconStyle: SVGICON.DataTable,
    eventKey: 'placement-students',
    // Canonical route for Placement Students
    to: 'placement-students',
    content: [],
  },
  {
    title: 'Applied Jobs',
    classsChange: 'mm-collapse',
    iconStyle: SVGICON.DataTable,
    eventKey: 'applied-jobs',
    to: 'applied-jobs',
    content: [],
  },
];
